/**
 * @generated SignedSource<<002f6131297a49addfb66fc42ed9505b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ContentDevice = "PC" | "MOBILE" | "%future added value";
export type ContentReportInput = {
  startOn: string;
  endOn: string;
  deviceType: ContentDevice;
};
export type ABTestContentReportPageContainer_Query$variables = {
  abtestSlug: string;
  abtestGroupSlug: string;
  input: ContentReportInput;
};
export type ABTestContentReportPageContainer_QueryVariables = ABTestContentReportPageContainer_Query$variables;
export type ABTestContentReportPageContainer_Query$data = {
  readonly abtestScenarioPageGroup: {
    readonly title: string;
    readonly page: {
      readonly url: string;
    };
  } | null;
  readonly abtestScenarioPage: {
    readonly title: string | null;
    readonly reportContent: {
      readonly totalUniqueUsers: number;
      readonly totalViews: number;
      readonly totalGoals: number;
      readonly viewportWidth: number | null;
      readonly viewportHeight: number | null;
      readonly previewImageUrl: string | null;
      readonly elements: ReadonlyArray<{
        readonly name: string;
        readonly previewImageUrl: string | null;
        readonly updatedDate: string;
        readonly views: number;
        readonly viewRate: number;
        readonly averageViewTime: number;
        readonly goals: number;
        readonly goalRate: number;
        readonly clicks: number;
        readonly clickRate: number;
        readonly position: {
          readonly x: number;
          readonly y: number;
          readonly width: number;
          readonly height: number;
        } | null;
      }>;
    } | null;
  } | null;
};
export type ABTestContentReportPageContainer_QueryResponse = ABTestContentReportPageContainer_Query$data;
export type ABTestContentReportPageContainer_Query = {
  variables: ABTestContentReportPageContainer_QueryVariables;
  response: ABTestContentReportPageContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "abtestGroupSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "abtestSlug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "abtestGroupSlug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "abtestSlug"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewImageUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ],
  "concreteType": "ContentAnalyticsResult",
  "kind": "LinkedField",
  "name": "reportContent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalUniqueUsers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalViews",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalGoals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewportWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewportHeight",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentElementMetric",
      "kind": "LinkedField",
      "name": "elements",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "views",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewRate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "averageViewTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "goals",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "goalRate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clicks",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clickRate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentElementPosition",
          "kind": "LinkedField",
          "name": "position",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "x",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "y",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestContentReportPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AbtestScenarioPageGroup",
        "kind": "LinkedField",
        "name": "abtestScenarioPageGroup",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "AbtestScenarioPage",
        "kind": "LinkedField",
        "name": "abtestScenarioPage",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ABTestContentReportPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AbtestScenarioPageGroup",
        "kind": "LinkedField",
        "name": "abtestScenarioPageGroup",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "AbtestScenarioPage",
        "kind": "LinkedField",
        "name": "abtestScenarioPage",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e55a71e22a5f502c7e8aaeafb2c989ac",
    "id": null,
    "metadata": {},
    "name": "ABTestContentReportPageContainer_Query",
    "operationKind": "query",
    "text": "query ABTestContentReportPageContainer_Query(\n  $abtestSlug: String!\n  $abtestGroupSlug: String!\n  $input: ContentReportInput!\n) {\n  abtestScenarioPageGroup(slug: $abtestGroupSlug) {\n    title\n    page {\n      url\n      id\n    }\n    id\n  }\n  abtestScenarioPage(slug: $abtestSlug) {\n    title\n    reportContent(input: $input) {\n      totalUniqueUsers\n      totalViews\n      totalGoals\n      viewportWidth\n      viewportHeight\n      previewImageUrl\n      elements {\n        name\n        previewImageUrl\n        updatedDate\n        views\n        viewRate\n        averageViewTime\n        goals\n        goalRate\n        clicks\n        clickRate\n        position {\n          x\n          y\n          width\n          height\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "20641a5e70fdc32a98e1917d4460199d";

export default node;
